const env = process.env.NODE_ENV

export default {
  env /* 'production' or 'development' */,
  network: {
    configMetadata: {
      url: '/api/v1/config_metadata',
      method: 'POST'
    },
    config: {
      url: '/api/v1/config',
      method: 'POST'
    }
  }
}



// WEBPACK FOOTER //
// ./src/config/index.js